import { ReportUploadPanel } from "@/components/report_upload_panel"

interface TargetUploadSectionProps {
  integrationId: string
  onUploaded: () => void
}

/** Upload Target's Payment Information export from Partners Online; queues a `sync-target` job. */
export function TargetUploadSection({ integrationId, onUploaded }: TargetUploadSectionProps) {
  return (
    <ReportUploadPanel
      endpoint="/api/admin/target/upload"
      fields={{ integration_id: integrationId }}
      accept={{ "text/csv": [".csv"] }}
      dropLabel="Drag and drop the Payment Information export"
      formatsLabel=".csv"
      successMessage={() => ({
        title: "Upload received",
        description: "Your Target payments and deductions will sync in the background.",
      })}
      onUploaded={onUploaded}>
      <div class="rounded-md border border-blue-200 bg-blue-50 p-3 text-sm text-blue-900 space-y-2">
        <p>Export your payment detail from Target Partners Online:</p>
        <ol class="list-decimal list-outside space-y-1 ml-5">
          <li>
            Log in at{" "}
            <a
              href="https://ve.partnersonline.com"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-blue-700">
              ve.partnersonline.com
            </a>
            .
          </li>
          <li>
            Go to <strong>Apps &amp; Reports</strong> → <strong>Accounts Payable: Domestic</strong> →{" "}
            <strong>Payment Information</strong>.
          </li>
          <li>
            Open a payment, then clear the <strong>payment date</strong> and <strong>payment number</strong> filters so
            every deduction is listed.
          </li>
          <li>
            Click the menu button (☰) in the top right and choose <strong>Export as CSV</strong>.
          </li>
        </ol>
      </div>
    </ReportUploadPanel>
  )
}
